// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.delete-popup {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 90%;
  position: relative;
  height: 200px;
  display: flex;
  justify-content: end;
  flex-direction: column;
}

.delete-title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #0C3688;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  color: white;
  padding: 10px 0;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cut-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  font-size: 20px;
  cursor: pointer;
}

.message-button-flex {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.buttons {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.cancelButton {
  background-color: white;
  border: 1px solid #0C3688;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100px;
  height: 45px;
}
.cancelButton:hover {
  background-color: #b3b3b3;
}

.deleteButton {
  background-color: red;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100px;
  height: 45px;
}
.deleteButton:hover {
  background-color: darkred;
}`, "",{"version":3,"sources":["webpack://./src/component/DeletePopup/DeletePopup.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACJ;;AAEA;EACI,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;AACJ;;AAEA;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AACJ;;AAEA;EACI,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;EACA,YAAA;EACA,YAAA;AACJ;AACI;EACI,yBAAA;AACR;;AAGA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;EACA,YAAA;EACA,YAAA;AAAJ;AAEI;EACI,yBAAA;AAAR","sourcesContent":[".overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.delete-popup {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    text-align: center;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    max-width: 400px;\n    width: 90%;\n    position: relative;\n    height: 200px;\n    display: flex;\n    justify-content: end;\n    flex-direction: column;\n}\n\n.delete-title {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #0C3688;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    color: white;\n    padding: 10px 0;\n    font-size: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.cut-icon {\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.message-button-flex {\n    margin-bottom: 10px;\n    display: flex;\n    flex-direction: column;\n}\n\n.buttons {\n    margin-top: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n}\n\n.cancelButton {\n    background-color: white;\n    border: 1px solid #0C3688;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    width: 100px;\n    height: 45px;\n\n    &:hover {\n        background-color: #b3b3b3;\n    }\n}\n\n.deleteButton {\n    background-color: red;\n    color: #fff;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    width: 100px;\n    height: 45px;\n\n    &:hover {\n        background-color: darkred;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
